<template>
  <v-list v-if="model">
    <v-list-tile class="tile-fix">
      <v-list-tile-content>
        <v-list-tile-title>{{ model.name }}</v-list-tile-title>
        <v-list-tile-sub-title>
          {{ model.zip }} &mdash;
          <template>{{ model.name }}</template>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn
          icon
          ripple
          @click="model = null">
          <v-icon color="grey lighten-1">close</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
  <v-autocomplete
    v-else
    v-model="model"
    :items="items"
    :error-messages="errorMessages"
    :loading="isLoading"
    :no-data-text="noDataText"
    :search-input.sync="search"
    :label="$t('label') + '*'"
    :placeholder="$t('placeholder')"
    :rules="rules"
    color="white"
    browser-autocomplete="off"
    item-text="descr"
    item-value="id"
    return-object/>
</template>

<script>
import helperApi from '@/api/HelperApi'
import debounce from 'lodash/debounce'

export default {
  name: 'SelectCity',
  props: ['value', 'errorMessages', 'rules'],
  data: () => ({
    entries: [],
    isLoading: false,
    model: null,
    search: null
  }),

  computed: {
    noDataText () {
      if (this.isLoading) {
        return this.$t('loading')
      }
      return this.$t('noData')
    },

    items () {
      return this.entries.map(entry => {
        return Object.assign({}, entry, { descr: `${entry.zip} ${entry.name}` })
      })
    },
    currentState () {
      if (this.model) {
        return this.statesById[this.model.state_id]
      }
    }
  },

  methods: {
    fetchCities: debounce(async function (e) {
      if (!e || e.length < 2) {
        return
      }
      const config = {}
      const isZip = /[0-9]/.test(e)
      if (isZip) {
        config.zip = e
      } else {
        config.name = e
      }
      this.isLoading = true
      this.entries = await helperApi.getCities(config)
      this.isLoading = false
    }, 250)
  },

  watch: {
    search: 'fetchCities',
    model () {
      this.$emit('input', this.model)
    }
  },
  i18n: {
    messages: {
      en: {
        label: 'City',
        loading: 'Loading...',
        noData: 'No cities found',
        placeholder: 'Type zip or city name to search...'
      },
      tr: {
        label: 'Şehir',
        loading: 'Yükleniyor...',
        noData: 'Şehir bulunamadı',
        placeholder: 'Aramak için posta kodunu ya da şehir ismini yazınız...'
      },
      de: {
        label: 'City',
        loading: 'Loading...',
        noData: 'Keine Stadt gefunden',
        placeholder: 'Nach Stadt oder Postleitzahl suchen...'
      },
      ru: {
        label: 'Город',
        loading: 'Загрузка...',
        noData: 'Не найдено ни одного города',
        placeholder: 'Введите почтовый индекс или название города для поиска...'
      }
    }
  },
  created () {
    if (this.value) {
      this.model = this.value
    }
  }
}
</script>

<style scoped>
  .tile-fix {
    margin: 0 -16px;
  }
</style>
